import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  container: {
    position: 'relative',
    width: '100%',
    '& .acr-paragraph-9': {
      margin: 0,
    },
    '& .acr-paragraph-8': {
      lineHeight: '1.25rem',
    },
  },
  required_tag: {
    color: colors.acura_red,
  },
  error_text: {
    color: colors.acura_red,
    position: 'absolute',
    width: '100%',
    marginTop: '0.3125rem',
  },
  input: {
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%',
    height: '3.125rem',
    backgroundColor: colors.off_white,
    border: 'solid 0.0625rem',
    borderColor: colors.mid_grey_2,
    padding: '0.875rem 1.125rem',
    zIndex: 1,
    fontSize: 'initial',
    '&:focus': {
      outline: `0.125rem solid ${colors.dark_grey_1}`,
      outlineOffset: '-0.0625rem',
    },
  },
});
